import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgCross(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    stroke: "inherit",
    strokeWidth: 3.0,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M1 1l21 21M1 22L22 1"
  })));
}
const MemoSvgCross = React.memo(SvgCross);
export default MemoSvgCross;